import * as z from "zod";

export const LooseProfile = z.looseObject({
  bio: z.nullable(z.string().max(500, "Bio Is not allowed to be greater than 500 characters.")),
  department: z.nullable(z.string().max(100, "Department Is not allowed to be greater than 100 characters.")),
  email: z.email("Invalid Email").max(100, "Email Is not allowed to be greater than 100 characters."),
  secondary_email: z.pipe(
    z.transform<string | null>((val) => (val === "" ? null : val)),
    z.nullable(
      z
        .email("Invalid Alternative Email")
        .max(100, "Alternative Email Is not allowed to be greater than 100 characters."),
    ),
  ),
  headshot: z.nullable(z.url()),
  job_title: z.nullable(z.string().max(100, "Job Title Is not allowed to be greater than 100 characters.")),
  last_name: z.nullable(z.string().max(100, "Last Name Is not allowed to be greater than 100 characters.")),
  legal_first_name: z.nullable(
    z.string().max(100, "Legal First Name Is not allowed to be greater than 100 characters."),
  ),
  location_city_id: z.nullable(z.any()),
  phone_number: z.nullish(z.string().regex(/^\+{0,1}(?:[0-9]){6,14}[0-9]$/, "Phone Number Is not valid.")),
  secondary_phone_number: z.nullish(
    z.string().regex(/^\+{0,1}(?:[0-9]){6,14}[0-9]$/, "Secondary Phone Number Is not valid."),
  ),
  preferred_first_name: z.nullish(
    z.string().max(100, "Preferred First Name Is not allowed to be greater than 100 characters."),
  ),
  pronouns: z.nullable(z.string().max(100, "Pronouns Are not allowed to be greater than 100 characters.")),
  work_location_city_id: z.nullable(z.any()),
  profile_admin_permissions: z.nullable(z.any()),
});

export default LooseProfile;
